/**
 * Created by Bart Decorte
 * Date: 2019-04-18
 * Time: 11:02
 */
import Page from '../pages/Page';

export default class ToolsIndex extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/website-tools/ToolsIndex.js